import { render, staticRenderFns } from "./treatment-overview.vue?vue&type=template&id=951350a4&"
import script from "./treatment-overview.vue?vue&type=script&lang=js&"
export * from "./treatment-overview.vue?vue&type=script&lang=js&"
import style0 from "./treatment-overview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports